@if (staffInfo | async; as data) {
  <div>
    @if (data) {
      <p-popover
        #op
        styleClass="overflow-hidden text-sm"
        appendTo="body"
        [dismissable]="true"
      >
        <ng-template #content>
          <!-- Dropdown Content -->
          @if (data) {
            <div
              class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2"
            >
              <div class="w-10rem line-height-1">
                <div class="text-sm font-medium text-800">
                  {{ data.name | titlecase }}
                </div>
                <div class="text-xs text-600 mt-1">{{ data.id }}</div>
              </div>
              <span
                class="bg-green-500 px-2 py-1 font-bold border-round text-white text-xxs uppercase ml-4 mt-1"
                >{{ data.role | titlecase }}</span
              >
            </div>
          }
          <!-- Dropdown Content -->
          <!-- Dropdown Footer -->
          <div class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs">
            <div class="flex align-items-center mb-2">
              <i class="fa fa-phone mr-2 text-500"></i>
              @if (data.mobile_number) {
                <span
                  >{{ data.mobile_country_code }} {{ data.mobile_number }}
                </span>
              } @else {
                Not specified
              }
            </div>
            <div class="flex align-items-center mb-1">
              <i class="fa fa-envelope font-light mr-2 text-500"></i>
              <span class="break-word">{{ data.email_id }}</span>
            </div>
          </div>
          <!-- Dropdown Footer -->
        </ng-template>
      </p-popover>
    }
    @if (data) {
      <div
        class="flex align-items-center cursor-pointer"
        (click)="toggleOverlay($event)"
        (mouseenter)="op().show($event)"
        (mouseleave)="op().hide()"
      >
        @if (data && data.ff_picture) {
          <p-avatar
            [image]="data.ff_picture"
            styleClass="mr-3 overflow-hidden border-round"
          />
        } @else {
          <p-avatar
            styleClass="text-sm mr-3"
            label="{{ data.name | titlecase | shortName }}"
          />
        }
        <span class="text-primary text-sm font-bold">{{ data.name }}</span>
      </div>
    }
  </div>
} @else {
  -
}
